import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpServiceService } from 'src/app/http-service.service';
import { UtilService } from 'src/app/util.service';
import { LoaderService } from 'src/app/loader.service';
import { AlertService } from 'src/app/alert.service';

@Component({
  selector: 'app-status-list',
  templateUrl: './status-list.component.html',
  styleUrls: ['./status-list.component.css']
})
export class StatusListComponent implements OnInit {
  services: any = {}
  json: any=[];
  constructor(private router: Router, 
    public httpService: HttpServiceService, public alertService: AlertService,
    public util:UtilService,
    public loaderService: LoaderService) {

  }

  async loadData(){
    this.loaderService.showLoader('Fetching Please wait ..').then(()=>{
      try{
        this.httpService.getApi('Status/getAllStatus').subscribe(async(res: any) => {
          
          if(res.success){
            this.json = res.success.status;
            console.log("json",this.json)
            await this.getServices()
            }
          this.loaderService.hideLoader();
         },(err)=>{
          
          this.loaderService.hideLoader();
          this.alertService.presentNetworkAlert();
         });
      }catch(e){
        this.loaderService.hideLoader();
      }
   
    });
  }

  ngOnInit() {
    this.loadData();
  }
  add() {
    this.router.navigate(['/status-add'])
  }

  details(data) {
    localStorage.setItem('statusDetails', JSON.stringify(data));
    this.router.navigate(['/status-details'])
  }


  getServices() {
    console.log("services")
    return new Promise(resolve => {
      this.json.forEach(element => {
          this.httpService.postApi(element['serviceType'], 'Servicetype/getServiceById/' + element['serviceType']).subscribe((res: any) => {
            if (res.success) {
              console.log(res)
               this.services[element['serviceType']] = res.success.servicetype
               console.log(this.services)
            }
          });
      })
      resolve(1)      
    })
  }

}
